import React from "react";
import { useNavigate } from "react-router-dom";

export default function SuccessfullyUpdatedAssessement({ setSelfAssessmentUpdated }) {
    const navigate = useNavigate();
    return (
        <div className="ContainerSubmitedSucess ">
            <div className="SubContainerSubmitedSucess d-flex flex-column justify-content-center align-items-center">
                <div className="d-flex justify-content-center align-items-center">
                    <img src="/HwImg/sucessIcon.png" alt="" />
                </div>
                <div className="d-flex justify-content-center align-items-center mt-4 sucessMsg1">
                    You Have successfully submitted the Self Assessment
                </div>
                

                <div className="d-flex justify-content-center align-items-center mt-3">
                    <button
                        className="okayBtnsucess"
                        onClick={() => {
                            setSelfAssessmentUpdated(false);
                            navigate('/SelfAssessment');
                        }}
                    >
                        Okay
                    </button>
                </div>
            </div>
        </div>
    );
}
